import { isEngineeringUser, useAuth } from "@assetwatch/auth";
import {
  AppShell,
  AppShellMobileNavigationTrigger,
  AssetWatchLogo,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  DEFAULT_PROFILE_MENU_LABELS,
  ProfileMenu,
  Sidebar,
  SidebarItem,
  TopBar,
  TopBarActions,
  TopBarContent,
  TopBarLeading,
} from "@assetwatch/ui";
import {
  createFileRoute,
  Link,
  Outlet,
  useRouterState,
} from "@tanstack/react-router";
import { useEffect } from "react";
import { useVisiblePages } from "../lib/pageAccess";
import { setMlFrontendRouteSentryContext } from "../lib/sentry";
import { pagePath } from "../pages/types";

function MlFrontendLayout() {
  const { signOut, user } = useAuth();
  const pathname = useRouterState({
    select: (state) =>
      state.resolvedLocation?.pathname ?? state.location.pathname,
  });
  const visiblePages = useVisiblePages();

  useEffect(() => {
    setMlFrontendRouteSentryContext(pathname);
  }, [pathname]);

  return (
    <AppShell>
      <TopBar>
        <TopBarLeading>
          <AppShellMobileNavigationTrigger />
          <span className="max-[599px]:hidden">
            <AssetWatchLogo aria-label="AssetWatch" />
          </span>
        </TopBarLeading>
        <TopBarContent>
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbPage>Home</BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </TopBarContent>
        <TopBarActions>
          <ProfileMenu
            engineeringOnly={isEngineeringUser(user)}
            labels={DEFAULT_PROFILE_MENU_LABELS}
            onSignOut={() => void signOut()}
          />
        </TopBarActions>
      </TopBar>
      <Sidebar mobileHeaderLeading={<AssetWatchLogo aria-label="AssetWatch" />}>
        <SidebarItem
          itemId="home"
          label="Home"
          leading={{ type: "icon", name: "home" }}
          render={<Link to="/" />}
          selected={pathname === "/"}
        />
        {visiblePages.map((page) => {
          const to = pagePath(page);
          return (
            <SidebarItem
              itemId={page.id}
              key={page.id}
              label={page.title}
              leading={{ type: "icon", name: page.icon }}
              render={<Link to={to} />}
              selected={pathname === to}
            />
          );
        })}
      </Sidebar>
      <Outlet />
    </AppShell>
  );
}

export const Route = createFileRoute("/_app")({
  component: MlFrontendLayout,
});
